export default __webpack_public_path__ + "static/screenFourthSectionUk-b8f174734956f534ae70e54da681e60b.webp";